import styled from "styled-components";
import { Modal } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

export const ModalContainer = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoadingIcon = styled(CircularProgress)`
  &:active,
  &:focus {
    outline: none;
    border: none;
  }
`;
